import { render, staticRenderFns } from "./BookingPrestaIssueListTable.vue?vue&type=template&id=20c73286&scoped=true"
import script from "./BookingPrestaIssueListTable.vue?vue&type=script&lang=js"
export * from "./BookingPrestaIssueListTable.vue?vue&type=script&lang=js"
import style0 from "./BookingPrestaIssueListTable.vue?vue&type=style&index=0&id=20c73286&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c73286",
  null
  
)

export default component.exports